// extracted by mini-css-extract-plugin
export var statsContainer = "styles-module__statsContainer___pHGmd";
export var statsSection = "styles-module__statsSection___xqtxL";
export var staticMapImage = "styles-module__staticMapImage___KLUoX";